import DBOperationsComb from "@/utils/dbOperationsComb";
import Helper from "@/utils/helper";

async function handleFormAttachmentUpload(file) {
  try {
    const attachmentId = Helper.getRandomUuid();
    const attachmentFileName = Helper.sanitizeFilename(
      `${attachmentId}.${Helper.getFileExtension(file.name)}`
    );
    const attachmentFilePath = `${Helper.getUsersFormTemplatesAttachmentsBucket(false)}/${attachmentFileName}`;
    const attachmentUrl = `${Helper.getRemoteStoragePrefix()}${Helper.getUsersFormTemplatesAttachmentsBucket()}/${attachmentFileName}`;
    const response = await DBOperationsComb.uploadToStorage(
      Helper.getSupabaseStorageBucket(),
      attachmentFilePath,
      file,
      { contentType: file.type }
    );

    if (response.error) {
      throw new Error(`Error during uploading image: ${response.error}`);
    }

    return {
      id: attachmentId,
      fileName: file.name,
      name: attachmentFileName,
      url: attachmentUrl,
      media_type: file.type,
      error: null
    };
  } catch (error) {
    return {
      error: error.message || "Failed to upload file"
    };
  }
}

export default {
  handleFormAttachmentUpload
};
